import React, { FC } from 'react';
import clsx from 'clsx';
import { ButtonLoading } from '../ButtonLoading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';

interface Props {
    orderTotalItemCount: string | number;
    isExportCSVLoading: boolean;
    exportCSV: () => Promise<void>
}

export const ExportCSVButton:FC<Props> = (props) => {
    const { orderTotalItemCount, isExportCSVLoading, exportCSV } = props;
    return (
        <div
            className={clsx(
                'd-flex align-items-center me-5 ms-auto',
                (orderTotalItemCount && !isExportCSVLoading) ? 'cursor-pointer' : 'cursor-not-allowed'
            )}
            onClick={async (): Promise<void> => (orderTotalItemCount && !isExportCSVLoading) && await exportCSV()}
        >
			<span className="text-muted fw-bolder">
				Export CSV
			</span>
            {
                isExportCSVLoading
                    ? <ButtonLoading additionalClass="ms-2 text-muted" />
                    : <FontAwesomeIcon icon={faFileCsv} width={15} className="text-muted ms-2 h-15px"/>
            }
        </div>
    );
};
